<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LikeButton',

  props: {
    /**
     * 自分でいいねしているかどうか
     */
    isLikedByMe: {
      type: Boolean,
      default: false,
    },

    /**
     * いいね総件数
     */
    total: {
      type: Number,
      default: 0,
    },
  },

  emits: ['click:like'],
})
</script>

<template>
  <div
    :class="[
      'o-action__like',
      { 'is-byMe': isLikedByMe },
    ]">
    <button
      class="o-action__like--item"
      @click="$emit('click:like')">
      <span class="o-action__like--icon">
        いいね
      </span>

      <span class="o-action__like--label is-count">
        {{ total }}
      </span>
    </button>
  <!-- /.o-action__like --></div>
</template>

<style lang="sass" scoped>
.o-action__like
  $root: &

  &.is-byMe
    #{$root}--item
      background-color: transparent
      border-color: transparent

    #{$root}--icon
        &::before
          background-image: url(@/images/icon/icon-claphands_active_01.gif)

    #{$root}--label
      &.is-count
        color: $font-light-orange

  & &--item
    width: 58px
    height: 32px
    display: flex
    align-items: center
    line-height: 1
    color: rgba($font-white, 0)
    white-space: nowrap
    padding: 0 0.5em
    background-color: rgba($bg-white, 1)
    border: 1px solid $border-x-light-gray
    border-radius: 100vh
    +transition

    +mouseover
      border-color: $border-light-orange
      box-shadow: $button-shadow

      #{$root}--icon
        &::before
          background-image: url(@/images/icon/icon-claphands_active_01.gif)

      #{$root}--label
        &.is-count
          color: $font-light-orange

  $icon-size: 28px
  & &--icon
    width: $icon-size
    height: $icon-size
    position: relative
    overflow: hidden
    color: rgba($font-white, 0)
    white-space: nowrap
    +transition

    &::before
      content: ""
      width: 100%
      height: 100%
      display: block
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      background:
        image: url(@/images/icon/icon-claphands_01.gif)
        position: center center
        repeat: no-repeat
        size: contain
      +transition

  & &--label
    &.is-count
      color: $font-gray
      font-size: $font-xx-small
      white-space: nowrap
      +transition
</style>
